import React from 'react';
import AccessibleHealthBanner from '../../components/AccessibleHealthBanner';
import AccessibleHealthProgram from '../../components/AccessibleHealthProgram';
import Banner from '../../components/Banner';
import FAQSection from '../../components/FAQSection';
import FooterSection from '../../components/FooterSection';
import InfoBanner from '../../components/InfoBanner';
import * as s from './styles';

const Homepage = () => {
  const faqs = [
    {
      question: 'Como o óleo de CBD promove o bem-estar?',
      answer:
        'O óleo de CBD promove o bem-estar ao interagir com o sistema endocanabinoide do corpo, ajudando a regular funções como o sono, o apetite e a resposta à dor.',
    },
    {
      question: 'Como devo usar o óleo de CBD para melhorar o bem-estar?',
      answer:
        'O óleo de CBD pode ser usado de diversas formas, incluindo sublingual, tópica e em alimentos. É importante seguir as orientações de dosagem do seu médico.',
    },
    {
      question: 'Quanto tempo leva para sentir os benefícios do óleo de CBD?',
      answer:
        'O tempo para sentir os benefícios do óleo de CBD pode variar, mas muitas pessoas relatam melhorias dentro de uma a duas semanas de uso regular.',
    },
    {
      question: 'É seguro usar óleo de CBD todos os dias?',
      answer:
        'Sim, o uso diário de óleo de CBD é geralmente considerado seguro. No entanto, é importante consultar um médico antes de iniciar qualquer regime de suplementos.',
    },
    {
      question: 'Quem pode se beneficiar deste programa especial?',
      answer:
        'Microempreendedores Individuais e inscritos no Bolsa Família podem se beneficiar deste programa especial de cannabis medicinal.',
    },
    {
      question: 'Quais são os benefícios incluídos no programa?',
      answer:
        'O programa inclui consultas médicas gratuitas, frete gratuito e óleo de cannabis a preço fixo mensal.',
    },
    {
      question: 'Como posso me inscrever no programa?',
      answer:
        'Para se inscrever, registre-se em nossa plataforma e indique sua condição de MEI ou recebedor do Bolsa Família.',
    },

    {
      question:
        'Como é garantida a qualidade e a segurança do óleo de cannabis fornecido?',
      answer:
        'A qualidade e a segurança são garantidas por meio de testes rigorosos e controle de qualidade em todas as etapas de produção.',
    },
  ];

  return (
    <>
      <s.Container>
        <Banner
          logoSrc='/assets/logo-big.svg' // Coloque o caminho do logo aqui
          subtitle='Descubra os Benefícios do Óleo de CBD'
          buttonText='Fale com um Médico'
          title='Transforme seu bem estar!'
          imageUrl='/assets/banner/background-banner.jpg' // Coloque o caminho da imagem aqui
        />
        <InfoBanner
          logoSrc='/assets/logo-blue.svg'
          imageSrc='/assets/banner/infobanner.jpg' // Coloque o caminho da imagem aqui
        />

        <AccessibleHealthBanner
          imageSrcDesktop='/assets/banner/saudeacessivel.jpg'
          imageSrcMobile='/assets/banner/saudeacessivel-mobile.jpg'
        />

        <AccessibleHealthProgram
          imageSrc='/assets/banner/causas.jpg'
          additionalImageSrc='/assets/banner/causas.jpg' // Coloque o caminho das imagens aqui
        />
        <FAQSection faqs={faqs} />
      </s.Container>
      <FooterSection logoSrc='/assets/logo.svg' />
    </>
  );
};

export default Homepage;
